export default __webpack_public_path__ + "static/media/box.f01e4aef.svg";